import TemporaryEcgHackedGraph from './TemporaryEcgHackedGraph'

export default TemporaryEcgHackedGraph
